// Parse the URL parameter
var dynamicContent = window.shopUtils.getParameterByName('dc');

$(document).ready(function () {
  $(".show-mac").click(function () {
    $("#windows-options").hide();
    $("#mac-options").show();
    $(".show-mac").addClass("selected");
    $(".show-windows").removeClass("selected");
  });
  $(".show-windows").click(function () {
    $("#windows-options").show();
    $("#mac-options").hide();
    $(".show-windows").addClass("selected");
    $(".show-mac").removeClass("selected");
  });
  // Check if the URL parameter is apple
  if (dynamicContent == 'mac') {
    $("#windows-options").hide();
    $("#mac-options").show();
    $(".show-mac").addClass("selected");
    $(".show-windows").removeClass("selected");
  }
});